import { useStaticQuery, graphql } from 'gatsby'

export default () => {
  const data = useStaticQuery(graphql`
    query Bio {
      contentfulBio {
          id,
          name
      }
    }
  `)

  return {
    id: data.contentfulBio.id,
    name: data.contentfulBio.name,
  }
}
